unable to read source [project]/packages/core/src/devtools/isDevToolsEnabled.ts